<template>
  <div class="move_header">
    <el-dialog v-dialogDrag :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="handleClose" width="547px" top="80px" title="复制到">
      <el-tree ref="tree" :props="defaultFileProps" node-key="folderId" class="tree" accordion highlight-current
        :data="treeData" @node-expand="treeExpand" @node-collapse="treeCollapse" @node-click="handleNodeClick">
        <template #default="{ data }">
          <span>
            <img v-if="data.folderType==51" :src="sheetSetDoc" class="img" alt="文件" />
            <img v-else :src="sheetSetFolder" class="img" alt="文件" />
            {{ data.folderName }}
          </span>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <span>
          <el-button size="small" @click="handleClose(true)">取消</el-button>
          <el-button type="primary" size="small" @click="confirmHandler()">确定</el-button>
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import sheetSetService from "@/CommonDP/service/sheetSet-service";
export default {
  props: {
    folderData: {
      type: Object,
      required: false,
      default: () => ({
        folderId: "folderId"
      })
    }
  },
  data() {
    return {
      sheetSetFolder: require("@/CommonDP/assets/sheetSet/sheetSetFolder.png"),
      sheetSetDoc: require("@/CommonDP/assets/sheetSet/sheetSetDoc.png"),
      visible: true,
      defaultFileProps: {
        children: "childList",
        label: "folderName"
      },
      clickFolderData: {},
      treeData: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj
    })
  },
  created() {
    this.getlocalTree();
  },
  methods: {
    // 查询目录树
    async getlocalTree() {
      const resArr = await sheetSetService.prjDrawingSetList(this.prjInfo.prjId);
      this.treeData = this.arrangeData(resArr.data);
    },
    arrangeData(nodes) {
      nodes.forEach((v) => {
        if (v.folderType === 51) {
          v.childList = [];
        } else {
          this.arrangeData(v.childList);
        }
      });
      return nodes;
    },
    // 点击目录树
    handleNodeClick(data) {
      this.clickFolderData = data;
    },
    // 关闭弹框
    handleClose() {
      this.visible = false;
      this.clickFolderData = {};
      this.$parent.sheetSetCopyShow = false;
    },
    // 确定
    async confirmHandler() {
      if (this.clickFolderData.folderNew === 1 && this.clickFolderData.folderType === 51) {
        await sheetSetService.prjDrawingSetCopy(this.folderData.folderId, this.clickFolderData.folderId);
        this.$message.success("复制成功");
        this.$parent.queryTreeData(1);
        this.handleClose();
      } else {
        this.$message.warning("请选择复制到图纸集的父级或同级");
      }
    },
    treeExpand(data, node) {
      node.isExpand = true;
      this.$nextTick(() => {
        if (this.$refs.tree) {
          this.$refs.tree.setCurrentKey(data.folderId);
        }
      });
    },
    treeCollapse(data, node) {
      node.isExpand = false;
      this.$nextTick(() => {
        if (this.$refs.tree) {
          this.$refs.tree.setCurrentKey(data.folderId);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.move_header {
  .el-dialog__body {
    padding: 20px;
    height: 500px;
  }
  .el-dialog__header {
    line-height: 24px;
  }
  .el-dialog__footer {
    line-height: 32px;
  }
}
</style>
<style  lang="scss" scoped>
.tree {
  margin-top: 10px;
  max-height: 450px;
  overflow: auto;
  .img {
    height: 16px;
    width: 18px;
    margin-right: 2px;
    user-select: none;
    vertical-align: bottom;
  }
}
</style>
